export default __webpack_public_path__ + "static/media/choi-smog.96df0983.jpg";